
console.log('Hello World')

const add = function (...numbers) {
	return numbers.reduce((acc, x) => acc + x, 0);
}

console.log(add(1, 2, 3));

console.log(add(2, 4, 10));

document.addEventListener("DOMContentLoaded", function () {


	setFooterColor();

	// --- END OF FOOTER COLOUR CODE
	toggleOpenClassOnMenu('menu-header-main-menu');

	// Run on page load
	checkAndHideButton();

	// Run whenever classes change
	const observer = new MutationObserver(checkAndHideButton);
	observer.observe(document.getElementById("main-site-header"), { attributes: true, attributeFilter: ["class"] });
});


const checkAndHideButton = function() {
	const header = document.getElementById("main-site-header");
	const buttonContainer = document.getElementById("slideout-reviews-button-container");

	if (header && buttonContainer) {
		if (header.classList.contains("opened")) {
			buttonContainer.style.display = "none";
		} else {
			buttonContainer.style.display = "";
		}
	}
}

const toggleOpenClassOnMenu  = function (menuID) {
	document.querySelectorAll('#menu-header-main-menu li.menu-item-has-children').forEach(function(li) {
		li.addEventListener('click', function(event) {
			event.stopPropagation(); // Prevent bubbling
			document.querySelectorAll('#menu-header-main-menu li.menu-item-has-children.opened').forEach(function(openLi) {
				if (openLi !== li) openLi.classList.remove('opened'); // Remove 'opened' from other LIs
			});
			this.classList.toggle('opened'); // Toggle 'opened' on clicked LI
		});
	});
}
const setFooterColor = function () {
// Get all elements with the class "flexible-content"
	let elements = document.querySelectorAll(".flexible-section");

	// Check if there are any elements with this class
	if (elements.length > 0) {
		// Get the last element
		let lastElement = elements[elements.length - 1];

		// Get its computed background color
		// Apply it to the #main-footer-signup element
		document.getElementById("main-footer-signup").style.backgroundColor = window.getComputedStyle(lastElement).backgroundColor;
	}}


// Jquery bits
jQuery(document).ready(function ($) {

	const modal = $('#postcode-modal');
	const closeModalButton = $('.close-modal');
	const submitButton = $('#submit-postcode');
	const postcodeInput = $('#postcode-input');

	$(".trigger-postcode-changer").on('click', function (e) {
		e.preventDefault();
		openModal();
	})

	function openModal() {
		modal.show();
	}

	function closeModal() {
		modal.hide();
	}

	closeModalButton.on('click', closeModal);

	submitButton.on('click', function () {
		const postcode = postcodeInput.val().trim();

		if (postcode) {
			$.ajax({
				url: postcodeAjax.ajax_url,  // WordPress AJAX URL
				type: 'POST',
				data: {
					action: 'set_postcode_session',
					postcode: postcode
				},
				success: function (response) {
					if (response.success) {
						closeModal();
						window.location.reload()
					} else {
						alert('Failed to save postcode');
					}
				},
				error: function () {
					alert('An error occurred while saving the postcode.');
				}
			});
		} else {
			alert('Please enter a valid postcode.');
		}
	});

});


